import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Nav, Button, Row, Col } from 'react-bootstrap';
import { objectGiaiDoanDaoTao, giaiDoanDaoTaoValue } from '@app/utils/define';

import HoiDongDaoDuc from '../hoiDongDaoDuc/HoiDongDaoDuc';
import SoLieuNghienCuuTab from '../soLieuNghienCuu/SoLieuNghienCuuTab';
import HocPhanBoSung from '../hocPhanBoSung/HocPhanBoSung';
import HocPhanTienSi from '../hocPhanTienSi/HocPhanTienSi';
import ChuyenDeTienSi from '../chuyenDeTienSi/ChuyenDeTienSi';
import TieuLuanTongQuan from '../tieuLuanTongQuan/TieuLuanTongQuan';
import BaoVeCoSo from '../baoVeCoSo/BaoVeCoSo';
import PhanBienDocLap from '../phanBienDocLap/PhanBienDocLap';

const GiaiDoanDaoTaoNCS = () => {
    const history = useHistory();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(giaiDoanDaoTaoValue.hoiDongDaoDuc);

    const handleGoBack = () => {
        history.goBack();
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case giaiDoanDaoTaoValue.hoiDongDaoDuc:
                return <HoiDongDaoDuc hoSoId={id} />;
            case giaiDoanDaoTaoValue.soLieuNghienCuu:
                return <SoLieuNghienCuuTab hoSoId={id} />;
            case giaiDoanDaoTaoValue.hocPhanBoSung:
                return <HocPhanBoSung hoSoId={id} />;
            case giaiDoanDaoTaoValue.hocPhanTienSi:
                return <HocPhanTienSi hoSoId={id} />;
            case giaiDoanDaoTaoValue.chuyenDeTienSi:
                return <ChuyenDeTienSi hoSoId={id} />;
            case giaiDoanDaoTaoValue.tieuLuanTongQuan:
                return <TieuLuanTongQuan hoSoId={id} />;
            case giaiDoanDaoTaoValue.baoVeCapCoSo:
                return <BaoVeCoSo hoSoId={id} />;
            case giaiDoanDaoTaoValue.phanBienDocLap:
                return <PhanBienDocLap hoSoId={id} />;
            default:
                return (
                    <div className="text-center p-5">
                        <h5>Tính năng đang được phát triển...</h5>
                    </div>
                );
        }
    };

    return (
        <div className="container-fluid">
            <Card className="mb-3 shadow-sm border-0" style={{ backgroundColor: '#f0f2f5' }}>
                <Card.Body className="p-3">
                    <Row className="mx-n1 mb-n2">
                        {objectGiaiDoanDaoTao.map((stage) => (
                            <Col md={4} key={stage.value} className="px-1 mb-2">
                                <div 
                                    className={`h-100 w-100 d-flex align-items-center justify-content-center text-center py-1 px-2 rounded btn ${activeTab === stage.value ? 'btn-primary text-white shadow-sm' : 'btn-light text-dark border'}`}
                                    onClick={() => setActiveTab(stage.value)}
                                    style={{ cursor: 'pointer', minHeight: '32px', transition: 'all 0.2s ease' }}
                                >
                                    <span className="font-weight-bold" style={{ fontSize: '1rem', lineHeight: '1.2' }}>{stage.label}</span>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>

            <div style={{ minHeight: 'calc(100vh - 300px)' }}>
                {renderTabContent()}
            </div>
        </div>
    );
};

export default GiaiDoanDaoTaoNCS;

